import { jsxs as f, jsx as s } from "react/jsx-runtime";
import * as g from "@radix-ui/react-progress";
import { forwardRef as B, useId as I } from "react";
import { c as R } from "./cn-DlLpp5ix.js";
const j = {
  xs: 4,
  sm: 6,
  md: 10
}, k = {
  accent: "var(--accent-default)",
  success: "var(--success)",
  warning: "var(--warning)",
  gradient: "var(--brand-gradient)"
};
function M(e, o, r) {
  return Math.max(o, Math.min(r, e));
}
const N = B(function({
  value: o,
  max: r = 100,
  indeterminate: a = !1,
  size: n = "sm",
  tone: i = "accent",
  label: t,
  showValue: d = !1,
  className: h,
  style: m,
  ...c
}, b) {
  const l = M(o, 0, r), u = a ? 0 : l / r * 100, y = j[n], w = c["aria-label"], v = I(), p = t != null, x = {
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
    width: "100%",
    ...m
  }, P = {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    height: y,
    background: "var(--bg-elevated)",
    borderRadius: "var(--radius-sm)"
  }, S = {
    width: a ? "40%" : `${u}%`,
    height: "100%",
    background: k[i],
    borderRadius: "var(--radius-sm)",
    transition: a ? void 0 : "width var(--duration-slower) var(--ease-out)"
  };
  return /* @__PURE__ */ f(
    "div",
    {
      ref: b,
      "data-ls-component": "progress-bar",
      "data-size": n,
      "data-tone": i,
      "data-indeterminate": a ? "true" : void 0,
      className: R(h),
      style: x,
      ...c,
      children: [
        (t || d) && /* @__PURE__ */ f(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              fontSize: "var(--text-xs)",
              color: "var(--text-secondary)"
            },
            children: [
              t ? /* @__PURE__ */ s("span", { id: v, children: t }) : /* @__PURE__ */ s("span", {}),
              d ? /* @__PURE__ */ s("span", { children: a ? "…" : `${Math.round(u)}%` }) : null
            ]
          }
        ),
        /* @__PURE__ */ s(
          g.Root,
          {
            value: a ? null : l,
            max: r,
            style: P,
            "aria-valuetext": a ? "loading" : void 0,
            "aria-labelledby": p ? v : void 0,
            "aria-label": p ? void 0 : w,
            children: /* @__PURE__ */ s(
              g.Indicator,
              {
                "data-ls-component": "progress-bar-indicator",
                "data-indeterminate": a ? "true" : void 0,
                style: S
              }
            )
          }
        )
      ]
    }
  );
});
N.displayName = "ProgressBar";
export {
  N as P
};
//# sourceMappingURL=ProgressBar-CTZZKLVV.js.map
